module.exports = __webpack_public_path__ + "static/fonts/Mont-RegularItalic.d5737d6.woff2";